import ServiceList from '@pages/services/ServiceList';
import React from 'react';

const Services = () => {
  return (
    <div className="container py-20">
      <div className="m-auto text-center max-w-3xl">
        <div className="text-3xl md:text-5xl font-medium">Our Services</div>
        <div className="mt-3 text-gray-500">
          Get where you need to go with ease! We offer comprehensive transport
          services including wheelchair accessible vehicles, airport transfers,
          and courier services for small parcels.
        </div>
      </div>
      <ServiceList />
    </div>
  );
};

export default Services;
